module.exports = __webpack_public_path__ + "static/media/timeline-mobile.56bef3d0.svg";